module.exports = __webpack_public_path__ + "static/media/Selfie_With_Passport.4b1045da.png";